






































































import {
  SfFooter, SfList, SfLink, SfImage,
} from '@storefront-ui/vue';
import SvgImage from '~/components/General/SvgImage.vue';
import { computed, defineComponent } from '@nuxtjs/composition-api';
import { addBasePath } from '~/helpers/addBasePath';
import { useConfig } from '~/composables';

export default defineComponent({
  components: {
    SfFooter,
    SfList,
    SfLink,
    SfImage,
    SvgImage,
  },
  setup() {
    const { config } = useConfig();

    const logoSrc = computed(() => {
      const baseMediaUrl = config.value.base_media_url;
      const logo = config.value.header_logo_src;

      return baseMediaUrl && logo ? `${baseMediaUrl}logo/${logo}` : '';
    });

    const logoWidth = computed(
      () => config.value.logo_width || '35',
    );

    const logoHeight = computed(
      () => config.value.logo_height || '34',
    );

    const logoAlt = computed(
      () => config.value.logo_alt || '',
    );

    return {
      addBasePath,
      logoAlt,
      logoHeight,
      logoSrc,
      logoWidth,
    };
  },
  data() {
    return {
      company: [{
        title: 'About us',
        link: 'https://innerecommerce.com/en/our-team/',
      },
      {
        title: 'Contact Us',
        link: 'https://innerecommerce.com/en/contact-us/',
      }],
      solutions: [{
        title: 'Address Verification',
        link: 'https://innerecommerce.com/en/address-verification/',
      },
      {
        title: 'Address Completion',
        link: 'https://innerecommerce.com/en/address-completion/',
      },
      {
        title: 'Email Validation',
        link: 'https://innerecommerce.com/en/email-validation/',
      }],
      legal: [{
        title: 'Privacy Policy',
        link: 'https://innerecommerce.com/en/privacy-policy/',
      },
      {
        title: 'Legal Notice',
        link: 'https://innerecommerce.com/en/legal-notice/',
      },
      {
        title: 'Terms and Conditions',
        link: 'https://innerecommerce.com/en/terms-and-conditions/',
      },
      {
        title: 'Cookie Policy',
        link: 'https://innerecommerce.com/en/cookie-policy/',
      }],
      social: [{
        link: 'https://innerecommerce.com/en/privacy-policy',
        image: '/homepage/gdpr-grey-small.webp',
        alt: 'gdpr',
      },
      {
        link: 'https://www.linkedin.com/in/vlosing/',
        svg: 'linkedin',
        width: '39',
        height: '39',
      }],
      isMobile: false,
      desktopMin: 1024,
    };
  },
});
